import {Widget} from "base/assets/js/widget/Widget.js";

export class Map extends Widget {

	sType = 'y';
	fLat = null;
	fLng = null;
	iZoom = 12;

	run() {

		this._my( { type: 's:sType', lat: 'f:fLat', lng: 'f:fLng' } );
		if( this.sType === 'g' ) {
			this._import( 'googleMaps' ).then( ::this.gmMap );
		} else if( this.sType === 'y' ) {
			this._import( 'yandexMaps' ).then( ::this.ymMap );
		}
	}

	ymMap( oYm ) {
		const oMap = new oYm.Map( this.bl(), {center: [this.fLat, this.fLng], zoom: this.iZoom, type: 'yandex#hybrid'});
		oMap.controls.add( 'zoomControl', { left: 5, top: 5 } );
		oMap.controls.add( 'typeSelector' );
		const oPlacemark = new oYm.Placemark( [ this.fLat, this.fLng] );
		oMap.geoObjects.add( oPlacemark );
	}

	gmMap( oGm ) {
		const oOpts = {
			center: new oGm.LatLng( this.fLat, this.fLng ),
			zoom: this.iZoom,
			mapTypeId: oGm.MapTypeId.TERRAIN
		};
		const oMap = new oGm.Map( this.bl(), oOpts );
		new oGm.Marker( { position: new oGm.LatLng( this.fLat, this.fLng ), map: oMap } );
	}

}